import { useQuery } from 'react-query'
import settingsQueryKeys from '../../../Profile/constants/settingsQueryKeys'
import { getCompanyInfo } from '../../../Profile/services/SettingsService'

export default () => useQuery(settingsQueryKeys.COMPANY_INFO, getCompanyInfo)
